import React from 'react';
import Header from '../components/layout/Header';
import MatchSchedule from '../components/sections/MatchSchedule';
import Footer from '../components/layout/Footer';

const SchedulePage = () => {
  return (
    <>
      <Header />
      <MatchSchedule />
      <Footer />
    </>
  );
};

export default SchedulePage;
